import template from './user-address-details.html';
import userAddressDetailsController from './user-address-details.controller';
import './user-address-details.styl';

let userAddressDetailsComponent = {
  restrict: 'E',
  bindings: {
    address: '<'
  },
  template,
  controller: userAddressDetailsController,
  controllerAs: 'vm'
};

export default userAddressDetailsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-address-details/user-address-details.component.js
 **/